import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation DeleteChatRating($id: ID!) {
    deleteChatRating(id: $id) {
      id
      status
      rating
    }
  }
`);
